<template>
  <app-navigation
    title="Registro de estudantes">
    <v-tabs
      v-model="active"
      color="primary"
      slider-color="secondary"
      dark grow
      @change="onTabChange"
      show-arrows>

      <v-tab
        v-for="item in tabs"
        :key="item.key"
        :to="`/registro/estudantes/${$route.params.id}`+item.to"
        exact ripple>
        {{ item.title }}
      </v-tab>

    </v-tabs>

     <v-container fluid grid-list-md>
      <v-layout
        justify-center>
        <v-flex xs12 sm8 md8>

          <router-view @tab-error="handleTabError" @tab-load-end="handleTabLoadEnd" />

          <v-layout column v-if="shouldShowSaveButton">
            <v-btn
              large class="mx-0 mt-4"
              form="tab-form" type="submit"
              color="primary">
                Salvar / Save
                <v-icon right dark>save</v-icon>
            </v-btn>
          </v-layout>

        </v-flex>
      </v-layout>
     </v-container>
  </app-navigation>
</template>

<script>
import AppNavigation from '@/layouts/AppNavigation'

/**
 * @group Tabs
 * Componente de abas para cadastro do aluno
 */
export default {
  name: 'StudentRegistrationTabs',

  components: {
    AppNavigation
  },

  data: () => ({
    active: 'null',
    previousRoute: null,
    tabs: [
      {
        key: 'tab1',
        title: 'Identificação / Identification',
        to: '/identificacao',
        saveEnabled: true,
        error: false,
        loading: true
      },
      {
        key: 'tab2',
        title: 'Dados familiares / Family data',
        to: '/dados_familiares',
        saveEnabled: false,
        error: false,
        loading: true
      },
      {
        key: 'tab3',
        title: 'Saúde/ Health',
        to: '/saude',
        saveEnabled: true,
        error: false,
        loading: true
      },
      {
        key: 'tab4',
        title: 'Rotina diária / Daily routine',
        to: '/rotina',
        saveEnabled: true,
        error: false,
        loading: true
      },
      {
        key: 'tab5',
        title: 'Direito de imagem / Image rights',
        to: '/direito_de_imagem',
        saveEnabled: true,
        error: false,
        loading: true
      },
      // {
      //   key: 'tab6',
      //   title: 'Autorização de retirada / Exit authorization',
      //   to: '/autorizacao_de_retirada',
      //   saveEnabled: false,
      //   error: false,
      //   loading: true
      // },
      {
        key: 'tab7',
        title: 'Documentação / Documentation',
        to: '/documentacao',
        saveEnabled: false,
        error: false,
        loading: true
      },
      {
        key: 'tab8',
        title: 'Rotina Escolar / School Routine',
        to: '/rotina_escolar',
        saveEnabled: false,
        error: false,
        loading: true
      }
    ]
  }),

  mounted () {
    const route = this.$route
    const { id } = route.params

    if (!this.isInsideTab()) {
      const routerPath = `/registro/estudantes/${id}/identificacao`
      this.$router.push({ path: routerPath })
      this.active = routerPath
    }
  },

  computed: {
    shouldShowSaveButton () {
      const tabParams = this.tabs.find(tab => this.active.includes(tab.to)) || {}
      return (tabParams.saveEnabled && !tabParams.error && !tabParams.loading) || false
    }
  },

  methods: {
    /**
     * @vuese
     * Método para verificar se existe alguma aba selecionada
     */
    isInsideTab () {
      let found = false
      const path = this.$route.path

      this.tabs.map(tabParams => {
        if (path.includes(tabParams.to)) found = true
      })

      return found
    },

    // @vuese Handle tab error
    handleTabError () {
      this.getCurrentTabParams().error = true
    },

    handleTabLoadEnd () {
      this.getCurrentTabParams().loading = false
    },

    getCurrentTabParams (route) {
      let lastRoutePath
      if (route) lastRoutePath = route.split('/').pop()
      else lastRoutePath = this.$router.currentRoute.path.split('/').pop()
      return this.tabs.find(tab => tab.to === `/${lastRoutePath}`)
    },

    onTabChange (route) {
      if (this.previousRoute) {
        this.getCurrentTabParams(route).loading = true
        this.getCurrentTabParams(route).error = false
        this.previousRoute = route
      } else {
        this.previousRoute = route
      }
    }
  }
}
</script>

<style lang="stylus">
.v-tabs .v-window__container
  height auto !important
</style>
